import React from "react";
import { Box } from "@mui/joy";
import type { Assignment } from "../../../api/assignments/Assignments.domain";
import AssignmentCard from "./AssignmentsCard";

export const AssignmentsList: React.FC<{
  assignments: Assignment[];
  showAcceptanceActions: boolean;
  editMode: boolean;
  onActionComplete: () => void;
}> = ({ assignments, showAcceptanceActions, editMode, onActionComplete }) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      gap: 1.5,
      width: "100%",
    }}
  >
    {assignments.map((assignment) => (
      <AssignmentCard
        key={assignment.assignmentId}
        assignment={assignment}
        showAcceptanceActions={showAcceptanceActions}
        editMode={editMode}
        onActionComplete={onActionComplete}
      />
    ))}
  </Box>
);
